import React from 'react'
import { Box, Button } from '@mui/material'
import { ExtensionState } from 'src/Libs/installation-extensions/types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  extensionState?: ExtensionState /* keeping this cause we will need it in the future */
}

/**
 * Footer content of the inexogy detail view.
 */
const FooterContent: React.FC<Props> = ({ extensionState }) => {
  const { t } = useCustomTranslation()

  const onClick = (): void => {
    window.open('https://shop.inexogy.com/wizard/step-0?partner=7P_35n3sISukF2lnbJJU1', '_blank')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <Button variant="outlined" onClick={onClick}>
        {t('installation-extensions.inexogy.modal.button')}
      </Button>
    </Box>
  )
}

export default FooterContent
